import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shop: 0, //购物状态
    message: 'Hello!',
  },

  mutations: {
    setShopAction (state,payload) {
      this.state.shop += payload.val;
    },
    increment (state, payload) {
      state.count += payload.step
    },
    decrement: state => state.count--,

    /**全局状态代码生成**/


  }
})



// WEBPACK FOOTER //
// ./src/utils/store.js